// Copyright (c) 2016 Deere & Company

import actions from '../action-list';

export const resetConfirmationModal = () => ({
    type: actions.RESET_CLAIM_JDP_CONFIRMATION_MODAL
});

export const setConfirmationModal = options => ({
    data: options,
    type: actions.SET_CLAIM_JDP_CONFIRMATION_MODAL
});



// WEBPACK FOOTER //
// ./src/claim/marketing/jdp/action-creators/confirmation-modal.js